import {
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import GenericDialog from "../GenericDialog";

export default function ConfirmDialog({
  open,
  setOpen,
  title = "Alert dialog",
  message = "",
  notes = null,
  reconfirmMessage = "Yes, I´m sure",
  withReconfirm = true,
  confirmText = "confirm",
  onClose = null,
  onCloseSuccess = null,
  successParams = null,
}) {
  const [reconfirm, setReconfirm] = React.useState(!withReconfirm);

  React.useEffect(() => {
    if (open) setReconfirm(!withReconfirm);
  }, [open, withReconfirm]);

  const handleClose = () => {
    setOpen(false);
    if (onClose !== null) onClose();
  };

  const handleCloseSuccess = () => {
    if (onCloseSuccess !== null) {
      if (successParams !== null) {
        onCloseSuccess(successParams);
      } else {
        onCloseSuccess();
      }
    }
    setOpen(false);
  };
  const actions = (
    <>
      <Button onClick={handleClose}>Cancel</Button>
      <Button
        onClick={handleCloseSuccess}
        color="primary"
        autoFocus
        disabled={withReconfirm && !reconfirm}
      >
        {confirmText}
      </Button>
    </>
  )
  return (
    <GenericDialog
      open={open}
      onClose={handleClose}
      title={title}
      actions={actions}
    >
        <Grid container spacing={2}>
          <Grid item>
            <Typography gutterBottom>{message}</Typography>
          </Grid>
          {withReconfirm && (
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={reconfirm}
                    onChange={(event) => setReconfirm(event.target.checked)}
                  />
                }
                label={reconfirmMessage}
              />
            </Grid>
          )}
          {notes !== null && (
            <Grid item>
              <Alert severity={"info"}>
                <Typography variant="body2" gutterBottom>
                  {notes}
                </Typography>
              </Alert>
            </Grid>
          )}
        </Grid>
    </GenericDialog>
  );
}
